module.exports = __webpack_public_path__ + "front/img/11.a5cb35b6.png";